<template>
  <transition name="fade-slide">
    <div v-if="isVisible" class="fixed bottom-6 right-6 z-50">
      <router-link 
        to="/contact"
        class="flex items-center justify-center w-12 h-12 bg-gray-900 dark:bg-white text-white dark:text-dark rounded-full shadow-lg shadow-black/10 dark:shadow-black/20 hover:shadow-xl hover:scale-105 transition-all duration-200"
      >
        <ArrowRight class="h-5 w-5" />
      </router-link>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { ArrowRight } from 'lucide-vue-next'

const isVisible = ref(false)

const handleScroll = () => {
  isVisible.value = window.scrollY > 600
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
  handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.fade-slide-enter-active, .fade-slide-leave-active { transition: all 0.2s ease; }
.fade-slide-enter-from, .fade-slide-leave-to { opacity: 0; transform: translateY(10px); }
</style>
